import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getUnitsListRequest, getUnitsListRequestError, getUnitsListRequestSuccess } from "../../slices/Content/GetUnitsList";

export const GetUnitsListApi = () => async (dispatch) => {

    try {
        dispatch(getUnitsListRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getUnitsList,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUnitsListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUnitsListRequestError(_error));
            });
    } catch (error) { }
};
